import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Inject, ViewChild} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {OphIconModule} from '../oph-icon/oph-icon.module';
import {OphXButtonComponent} from '../oph-x-button/oph-x-button.component';
import {SnackbarIconNamePipe} from './snackbar-icon-name.pipe';

@Component({
  selector: 'oph-snackbar',
  standalone: true,
  imports: [OphXButtonComponent, OphIconModule, SnackbarIconNamePipe],
  templateUrl: './oph-snackbar.component.html',
  styleUrl: './oph-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphSnackbarComponent implements AfterViewInit {
  @ViewChild('messageText') messageText!: ElementRef;
  private readonly DEFAULT_DURATION = 5000; // 5 seconds in milliseconds

  snackBarRef = inject(MatSnackBarRef);

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {message: string; type: 'newTaskAssigned' | 'taskTriggered' | 'taskCompleted' | 'error'}
  ) {}

  ngAfterViewInit() {
    // Dismiss snackbar after default duration
    setTimeout(() => {
      this.snackBarRef.dismiss();
    }, this.DEFAULT_DURATION);
  }
}
